import { restApi } from '../../api/restApiSlice';

export type SchedulerSettingsResult = {
  data: {
    id: string;
    rule: string;
    cache_freshness_hours: number;
    affected_urls: number;
  }[];
};

export type SchedulerSettingBody = {
  domain: string;
  rule: string;
  cache_freshness_hours: number;
};
const schedulerSettingsApiSlice = restApi.injectEndpoints({
  endpoints: (builder) => ({
    getSchedulerSettings: builder.query<SchedulerSettingsResult, string>({
      query: (domain) => ({ url: `/v3/domains/scheduler-settings`, method: 'GET', params: { domain } }),
      providesTags: ['schedulerSettings'],
    }),
    addSchedulerSettings: builder.mutation<void, SchedulerSettingBody>({
      query: (body) => ({ url: '/v3/domains/scheduler-settings', method: 'POST', body }),
      invalidatesTags: ['schedulerSettings'],
    }),
    deleteSchedulerSettings: builder.mutation({
      query: (id) => {
        return { url: `/v3/domains/scheduler-settings`, method: 'DELETE', params: { id } };
      },
      invalidatesTags: ['schedulerSettings'],
    }),
  }),
});

export const { useGetSchedulerSettingsQuery, useAddSchedulerSettingsMutation, useDeleteSchedulerSettingsMutation } =
  schedulerSettingsApiSlice;
